import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FeedItem, SourceType } from './new-internet.model';

@Component({
    selector: 'app-ni-stream',
    templateUrl: './feed-stream.component.html',
    styleUrls: ['./feed-stream.component.scss'],
    standalone: false
})
export class FeedStreamComponent {
  @Input() items: FeedItem[] = [];
  @Input() errors: { [feedUrl: string]: string } = {};
  @Input() loading = false;
  @Input() search = '';
  @Output() open = new EventEmitter<FeedItem>();
  @Output() toggleLike = new EventEmitter<FeedItem>();

  unreadOnly = false;
  sourceFilter: '' | SourceType = '';

  get errorCount(): number {
    return Object.keys(this.errors).length;
  }

  get visibleItems(): FeedItem[] {
    const q = this.search.trim().toLowerCase();
    return this.items.filter(it => {
      if (this.unreadOnly && it.read) { return false; }
      if (this.sourceFilter && it.sourceType !== this.sourceFilter) { return false; }
      if (q && !it.title.toLowerCase().includes(q) && !it.source.toLowerCase().includes(q)) {
        return false;
      }
      return true;
    });
  }

  trackByHash(_: number, item: FeedItem): string {
    return item.itemHash;
  }
}
